import { useState, useEffect } from "react";

function TallyResults({ votes }) {
  const [tally, setTally] = useState([]);
  useEffect(() => {
    if (votes) {
      let votesPositive = 0;
      let votesNegative = 0;
      let votesAbstain = 0;
      let votesRecuse = 0;
      for (const v of votes) {
        switch (v.counts) {
          case "positive":
            votesPositive++;
            break;
          case "negative":
            votesNegative++;
            break;
          case "recuse":
            votesRecuse++;
            break;
          case "abstain":
            votesAbstain++;
            break;
          default:
            break;
        }
      }
      setTally([votesPositive, votesNegative, votesAbstain, votesRecuse]);
    }
  }, [votes]);

  return (
    <div className="flex flex-col space-y-2">
      {tally.map((x, index) => {
        return (
          <div
            className={`rounded-lg px-4 py-2 flex items-center
    ${index === 0 && "bg-green-700"}
    ${index === 1 && "bg-red-700"}
    ${index === 2 && "bg-yellow-300"}
    `}
            key={index + 340}
          >
            <p
              className={`text-sm 2xl:text-base font-medium
${index === 0 && "text-white"}
${index === 1 && "text-white"}
${index === 2 && "text-gray-800"}
`}
            >
              <span className="mr-4 2xl:mr-8">Votes&#58;</span>
              {x}
            </p>
          </div>
        );
      })}
    </div>
  );
}

export default TallyResults;
